import { defineMessages } from 'react-intl';
import textCenteredSVG from '@plone/volto/icons/align-center.svg';
import textLeftSVG from '@plone/volto/icons/align-left.svg';
import textRightSVG from '@plone/volto/icons/align-right.svg';

// TODO: Deduplicar strings de tamanho - small, large, etc
const messages = defineMessages({
  buttonLabel: { id: 'Button Label', defaultMessage: 'Button Label' },
  button: { id: 'Button', defaultMessage: 'Button' },
  layout: { id: 'Layout', defaultMessage: 'Layout' },
  linkUrl: { id: 'Link URL', defaultMessage: 'Link URL' },
  variation: { id: 'Variation', defaultMessage: 'Variation' },
  default: { id: 'Default', defaultMessage: 'Default' },
  primary: { id: 'Primary', defaultMessage: 'Primary' },
  secondary: { id: 'Secondary', defaultMessage: 'Secondary' },
  isCircle: { id: 'Circle', defaultMessage: 'Circle' },
  icon: { id: 'Icon', defaultMessage: 'Icon' },
  iconDescriptionPart1: {
    id: 'Icon description part 1',
    defaultMessage: 'You can find the available icons at',
  },
  iconDescriptionPart2: {
    id: 'Icon description part 2',
    defaultMessage:
      '. For example, you can use "arrow_back" for an Arrow Back icon. You can find the name in the right menu by clicking on the icon.',
  },
  align: { id: 'Align', defaultMessage: 'Align' },
  left: { id: 'Left', defaultMessage: 'Left' },
  center: { id: 'Center', defaultMessage: 'Center' },
  right: { id: 'Right', defaultMessage: 'Right' },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
});

export const ButtonSchema = ({ intl, data }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.button),
        fields: ['label', 'icon', 'href', 'openLinkInNewTab'],
      },
      {
        id: 'layout',
        title: intl.formatMessage(messages.layout),
        fields: ['align', 'variation', 'isCircle'],
      },
    ],
    properties: {
      label: {
        title: intl.formatMessage(messages.buttonLabel),
        isDisabled: data.isCircle,
      },
      href: {
        title: intl.formatMessage(messages.linkUrl),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title'],
        allowExternals: true,
      },
      align: {
        title: intl.formatMessage(messages.align),
        required: false,
        default: 'center',
        type: 'string',
        widget: 'buttons',
        actions: ['left', 'center', 'right'],
        actionsInfoMap: {
          left: [textLeftSVG, intl.formatMessage(messages.left)],
          center: [textCenteredSVG, intl.formatMessage(messages.center)],
          right: [textRightSVG, intl.formatMessage(messages.right)],
        },
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
      variation: {
        title: intl.formatMessage(messages.variation),
        noValueOption: false,
        default: 'default',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['default', intl.formatMessage(messages.default)],
          ['secondary', intl.formatMessage(messages.secondary)],
        ],
      },
      isCircle: {
        title: intl.formatMessage(messages.isCircle),
        type: 'boolean',
      },
      icon: {
        id: 'icon',
        title: intl.formatMessage(messages.icon),
        description: (
          <>
            {intl.formatMessage(messages.iconDescriptionPart1)}{' '}
            <a
              href="https://fonts.google.com/icons"
              target="_blank"
              rel="noreferrer"
            >
              Material Symbols and Icons
            </a>
            {intl.formatMessage(messages.iconDescriptionPart2)}
          </>
        ),
      },
    },
    required: [],
  };
};
